import Form from "./components/Form";

export function App(){

  return(
    <>
      <Form />
      <div className="attribution">
        Challenge by{" "}
        <a
          href="https://www.frontendmentor.io?ref=challenge"
          target="_blank"
          rel="noreferrer"
        >
          Frontend Mentor
        </a>
        . Coded by <a href="https://github.com/Nikhila-DN/Contact-Form.git">Nikhila</a>.
      </div>
    </>
  )
}

export default App;